export const INE_DASHBOARD_START_LOADING = "INE_DASHBOARD_START_LOADING";
export const INE_DASHBOARD_END_LOADING = "INE_DASHBOARD_END_LOADING";

export const SET_INE_DASHBOARD_FILTER_SEARCH = "SET_INE_DASHBOARD_FILTER_SEARCH";
export const SET_INE_DASHBOARD_FILTER_MINE_ONLY = "SET_INE_DASHBOARD_FILTER_MINE_ONLY";

export const INE_DASHBOARD_DRAFT_LOADED = "INE_DASHBOARD_DRAFT_LOADED";
export const INE_DASHBOARD_NEW_LOADED = "INE_DASHBOARD_NEW_LOADED";
export const INE_DASHBOARD_PENDING_APPROVAL_LOADED = "INE_DASHBOARD_PENDING_APPROVAL_LOADED";
export const INE_DASHBOARD_REJECTED_LOADED = "INE_DASHBOARD_REJECTED_LOADED";
export const INE_DASHBOARD_SALES_ACTION_LOADED = "INE_DASHBOARD_SALES_ACTION_LOADED";
export const INE_DASHBOARD_APPROVAL_OF_CONTRACT_LOADED = "INE_DASHBOARD_APPROVAL_OF_CONTRACT_LOADED";
export const INE_DASHBOARD_ISSUE_WORK_ORDER_FORM_LOADED = "INE_DASHBOARD_ISSUE_WORK_ORDER_FORM_LOADED";
export const INE_DASHBOARD_PERFORM_INSPECTION_LOADED = "INE_DASHBOARD_PERFORM_INSPECTION_LOADED";
export const INE_DASHBOARD_AWAITING_SIGNATURE_LOADED = "INE_DASHBOARD_AWAITING_SIGNATURE_LOADED";
export const INE_DASHBOARD_COMPLETED_LOADED = "INE_DASHBOARD_COMPLETED_LOADED";
export const INE_DASHBOARD_CLOSED_LOADED = "INE_DASHBOARD_CLOSED_LOADED";
export const INE_DASHBOARD_ABORTED_LOADED = "INE_DASHBOARD_ABORTED_LOADED";

export const INE_DASHBOARD_AREA_MANAGER_USER_LOADED = "INE_DASHBOARD_AREA_MANAGER_USER_LOADED";
export const INE_DASHBOARD_TECHNICAL_MANAGER_USER_LOADED = "INE_DASHBOARD_TECHNICAL_MANAGER_USER_LOADED";
export const INE_DASHBOARD_INSPECTOR_USER_LOADED = "INE_DASHBOARD_INSPECTOR_USER_LOADED";
export const INE_DASHBOARD_FINANCE_USER_LOADED = "INE_DASHBOARD_FINANCE_USER_LOADED";

export const INE_DASHBOARD_USER_SEARCH_LOADED = "INE_DASHBOARD_USER_SEARCH_LOADED";
